var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsEnum, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { MessagingDealer } from '../../../enums';
import { MessagingTemplateButtonDto } from '../response';
export class SendMessageMessageDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SendMessageMessageDto.prototype, "reservationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendMessageMessageDto.prototype, "receiverNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendMessageMessageDto.prototype, "content", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => MessagingTemplateButtonDto),
    IsOptional(),
    __metadata("design:type", Array)
], SendMessageMessageDto.prototype, "buttons", void 0);
export class SendMessagesDto {
}
__decorate([
    IsEnum(MessagingDealer),
    __metadata("design:type", String)
], SendMessagesDto.prototype, "dealer", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SendMessagesDto.prototype, "templateCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SendMessagesDto.prototype, "senderNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SendMessagesDto.prototype, "title", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SendMessageMessageDto),
    __metadata("design:type", Array)
], SendMessagesDto.prototype, "messages", void 0);
